import { HeadCell, ACTION} from '../../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'Veiculo', label: 'Veículo' },
  { id: 'Satus', label: 'Status' },
  { id: 'Paletes', label: 'Paletes' },
  { id: 'Iniciar', label: 'Iniciar' },
  { id: 'Finalizar', label: 'Finalizar' },
  { id: ACTION, label: ''},
];
